"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@headlessui/react");
var _reactFeather = require("react-feather");
var _ModalFooter = require("./ModalFooter");
var _ModalBody = require("./ModalBody");
var _ModalHeader = require("./ModalHeader");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  root: "relative z-40",
  base: "relative flex flex-col overflow-hidden rounded-t-16 bg-white px-24 py-24 shadow-xl transition-all max-h-9/10 s768:max-h-4/5 w-full s576:rounded-b-16 s768:px-32",
  size: {
    sm: "s576:max-w-lg",
    md: "s768:max-w-2xl",
    lg: "s992:max-w-4xl"
  },
  backdrop: "fixed inset-0 bg-gray-171731",
  backdropAnimation: {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-50",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-50",
    leaveTo: "opacity-0"
  },
  panelAnimation: {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4",
    enterTo: "opacity-100 translate-y-0",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0",
    leaveTo: "opacity-0 translate-y-4"
  },
  center: "fixed inset-0 flex min-h-full justify-center items-end s576:items-center",
  closeBtn: {
    position: "absolute right-0 top-0 pr-24 pt-24",
    base: "cursor-pointer text-gray-65657b hover:text-gray-171731 focus:outline-none focus-visible:outline-3667e9",
    size: "h-24 w-24"
  }
};
const ModalComponent = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    open,
    onClose,
    closeIcon = true,
    size = "sm",
    unmount,
    initialFocus,
    children,
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react2.Transition.Root, {
    show: open,
    as: _react.Fragment
  }, /*#__PURE__*/_react.default.createElement(_react2.Dialog, {
    as: "div",
    onClose: onClose,
    className: THEME.root,
    unmount: unmount,
    initialFocus: initialFocus
  }, /*#__PURE__*/_react.default.createElement(_react2.Transition.Child, {
    as: _react.Fragment,
    enter: THEME.backdropAnimation.enter,
    enterFrom: THEME.backdropAnimation.enterFrom,
    enterTo: THEME.backdropAnimation.enterTo,
    leave: THEME.backdropAnimation.leave,
    leaveFrom: THEME.backdropAnimation.leaveFrom,
    leaveTo: THEME.backdropAnimation.leaveTo
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: THEME.backdrop
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: THEME.center
  }, /*#__PURE__*/_react.default.createElement(_react2.Transition.Child, {
    as: _react.Fragment,
    enter: THEME.panelAnimation.enter,
    enterFrom: THEME.panelAnimation.enterFrom,
    enterTo: THEME.panelAnimation.enterTo,
    leave: THEME.panelAnimation.leave,
    leaveFrom: THEME.panelAnimation.leaveFrom,
    leaveTo: THEME.panelAnimation.leaveTo
  }, /*#__PURE__*/_react.default.createElement(_react2.Dialog.Panel, _extends({
    className: (0, _classnames.default)(THEME.base, THEME.size[size], className),
    as: "div",
    ref: ref
  }, props), closeIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: THEME.closeBtn.position
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: THEME.closeBtn.base,
    "aria-label": "Close",
    onClick: () => onClose(false)
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.X, {
    className: THEME.closeBtn.size,
    "aria-hidden": "true"
  }))), children)))));
});
ModalComponent.displayName = "Modal";
const Modal = Object.assign(ModalComponent, {
  Header: _ModalHeader.ModalHeader,
  Body: _ModalBody.ModalBody,
  Footer: _ModalFooter.ModalFooter
});
exports.Modal = Modal;